import HttpClient from './utils/HttpClient';
import APIError from '../errors/APIError';

import { IUnitOfMeasurement } from '../models';

class UnitsOfMeasurementService {
  private httpClient = HttpClient;

  public async listUnitsOfMeasurement(
    companyId: number,
  ): Promise<IUnitOfMeasurement[]> {
    try {
      const response = await this.httpClient.get(
        `/companies/${companyId}/units-of-measurement`,
      );

      return response.data;
    } catch (error) {
      const parsedError = error as any;

      let errorMessage = parsedError?.response?.data?.message;

      if (!errorMessage) {
        errorMessage = 'Erro ao tentar listar as unidades de medida';
      }

      throw new APIError(errorMessage);
    }
  }
}

export default new UnitsOfMeasurementService();
